export default "__VITE_ASSET__kfolNVTJ__"